
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artikler/[slug]",
      function () {
        return require("private-next-pages/artikler/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artikler/[slug]"])
      });
    }
  